import { render } from "./nonAddTip.vue?vue&type=template&id=3e295886&scoped=true"
import script from "./nonAddTip.vue?vue&type=script&lang=js"
export * from "./nonAddTip.vue?vue&type=script&lang=js"

import "./nonAddTip.vue?vue&type=style&index=0&id=3e295886&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e295886"]])

export default __exports__